import React, { useState, useEffect, useRef } from "react";
import { Radio, Space, Button  } from 'antd';
import ImageDisplay from "../../components/ImageDisplay/ImageDisplay";

// function answerStringToIndex(str){
//     return str.charCodeAt(0)-'A'.charCodeAt(0);
// }
function SingleChoice (props){

    const {question, options, correctAnswer, reason, selectOption, url, mode} = props;
    console.log('props', props);
    // const isCorrect = selectOption === answerStringToIndex(correctAnswer);
    const isCorrect = selectOption === (correctAnswer);
    const startTime = useRef(null);

    useEffect(()=>{
        startTime.current = Date.now();
    }, [])
    const handleValueChange = (e)=>{
        const timeSpend = Date.now() - startTime.current;
        props.valueChange({...props, selectOption: e.target.value, time_spend: timeSpend});
        props.onSubmit({...props, selectOption: e.target.value, time_spend: timeSpend, isCorrect: e.target.value === correctAnswer});
    }

    const getAnswerOptionBorderStyle = (item, index)=>{
        let result = 'white';
        if(mode === 'test'){
            return result;
        }
        if(index === (correctAnswer)){
            if(selectOption || selectOption === 0){
                // if(isCorrect){
                    result = '#EDF7ED';
                // }else{
                //     result = '#FFF2F4';
                // }
            }
        }
        if(index === selectOption){
            if(isCorrect){
                result = '#EDF7ED';
            }else{
                result = '#FFF2F4';
            }
        }
        return result;
    }
    return (
        <Space direction="vertical" className= 'h-100 mt-2 w-100'>
            <p style={{fontWeight: 'bold', fontSize: '14px'}}>
                {props.index + 1} : {question}
            </p>
            <div style={{display: 'flex', justifyContent: 'center'}}>
                <ImageDisplay imgList={url}/>
            </div>

            <Radio.Group onChange={handleValueChange} value={selectOption} style={{width: '100%'}} disabled={mode === 'study' && (selectOption || selectOption === 0)}>
                <Space direction="vertical" style={{width: '100%', }}>
                    {options.map((ele, key)=>
                        <Radio key={key} value={key} style={{width: '100%', border: '0.5px lightblue solid', backgroundColor: getAnswerOptionBorderStyle(ele, key), borderRadius: '5px', padding: '10px'}}>
                            {ele}
                        </Radio>)}
                </Space>
            </Radio.Group>
            {(selectOption || selectOption === 0) && !isCorrect && reason ?
                <p style={{fontSize: '14px', paddingTop: '5px'}}>Explaination: {reason}</p>
                :
                null
            }
        </Space>
    );
}

export default SingleChoice;